export default __webpack_public_path__ + "static/media/result_crown.298fb572.png";